<form [formGroup]="dateForm" (ngSubmit)="onSubmit()" class="pt-1">
  <div class="font-bold mt-0 mb-1">{{ "DISCOVERY_DATE" | translate }}</div>
  <mat-form-field>
    <input
      matInput
      [matDatepicker]="picker"
      formControlName="selectedDate"
      [max]="today"
      placeholder="{{ 'PICK_A_DATE' | translate }}"
    />
    <mat-hint class="text-grey dark:text-borders-dark">DD/MM/YYYY</mat-hint>
    <mat-datepicker-toggle
      matSuffix
      [for]="picker"
      [disabled]="discoveredOnRelease"
    ></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
  <mat-checkbox
    class="white-border-checkbox mt-[12px] block italic"
    [checked]="discoveredOnRelease"
    [disabled]="!workReleaseDate"
    (change)="onDiscoveredOnReleaseChange($event.checked)"
  >
    <span class="ml-1">{{ "WORK_DISCOVERED_ON_RELEASE" | translate }}</span>
  </mat-checkbox>
  @if (item.type !== worksTypes.Movie) {
  <mat-slide-toggle class="mt-[12px] italic" formControlName="markCompleted">
    {{ "MARK_COMPLETED" | translate }}
  </mat-slide-toggle>
  }
  <button
    type="submit"
    [disabled]="saving || dateForm.invalid"
    [attr.aria-busy]="saving"
  >
    {{ submitText }}
  </button>
</form>
